import type { JSX } from 'react';
import type { ServiceId } from '@inventohub/shared';

export function ServiceIcon({ id }: { id: ServiceId }): JSX.Element {
  const title = id;
  return (
    <svg
      className="service-icon"
      viewBox="0 0 24 24"
      width="28"
      height="28"
      aria-hidden="true"
      data-icon={title}
    >
      {iconPath(id)}
    </svg>
  );
}

function iconPath(id: ServiceId): JSX.Element {
  switch (id) {
    case 'scan-qr':
      return (
        <path
          fill="currentColor"
          d="M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm10-2h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm4 8h2v2h-2v-2z"
        />
      );
    case 'events':
      return (
        <path
          fill="currentColor"
          d="M7 2h2v2h6V2h2v2h3v18H4V4h3V2zm12 8H5v10h14V10zM6 6v2h12V6H6z"
        />
      );
    case 'availability':
      return (
        <path
          fill="currentColor"
          d="M7 2h2v2h6V2h2v2h3v18H4V4h3V2zm12 8H5v10h14V10zM8 13h2v2H8v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zM8 17h8v2H8v-2z"
        />
      );
    case 'inventory':
      return <path fill="currentColor" d="M4 4h16v4H4V4zm0 6h16v10H4V10zm3 2v2h10v-2H7z" />;
    case 'assets':
      return <path fill="currentColor" d="M4 6h16v4H4V6zm0 6h7v8H4v-8zm9 0h7v8h-7v-8z" />;
    case 'totes':
      return <path fill="currentColor" d="M3 7h18v13H3V7zm2 2v9h14V9H5zm3-5h8l2 3H6l2-3z" />;
    case 'bins':
      return <path fill="currentColor" d="M4 5h16l-1.5 15h-13L4 5zm4 3v9h2V8H8zm6 0v9h2V8h-2z" />;
    case 'trailers':
      return (
        <path
          fill="currentColor"
          d="M2 8h14v8H2V8zm14 3h4l2 3v2h-6v-5zM5 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        />
      );
    case 'replacements':
      return (
        <path
          fill="currentColor"
          d="M12 2 4 6v6c0 5 3.4 9.4 8 10 4.6-.6 8-5 8-10V6l-8-4zm0 4 4.5 2.2-.8 1.8L12 8.2 8.3 10l-.8-1.8L12 6z"
        />
      );
    case 'users':
      return (
        <path
          fill="currentColor"
          d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-4 0-8 2-8 5v1h16v-1c0-3-4-5-8-5z"
        />
      );
    case 'labels':
      return <path fill="currentColor" d="M3 7h11l7 5-7 5H3V7zm3 3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z" />;
    case 'audit':
      return (
        <path
          fill="currentColor"
          d="M6 3h9l5 5v13H6V3zm9 1.5V9h4.5L15 4.5zM8 12h8v2H8v-2zm0 4h8v2H8v-2z"
        />
      );
    case 'settings':
      return (
        <path
          fill="currentColor"
          d="M10 2h4l.6 2.4 2.2 1.2 2.4-.6 2 3.4-1.8 1.8v2.4L21.2 16l-2 3.4-2.4-.6-2.2 1.2L14 22h-4l-.6-2.4-2.2-1.2-2.4.6-2-3.4 1.8-1.8V11.4L2.8 8l2-3.4 2.4.6L9.4 4 10 2zm2 7a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"
        />
      );
    case 'help':
      return (
        <path
          fill="currentColor"
          d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 16h-2v-2h2zm1.1-6.5-.9.9A2.5 2.5 0 0 0 12 15h-1v-1a3.5 3.5 0 0 1 1-2.5l1.2-1.2A1.5 1.5 0 1 0 10.5 9H9a3.5 3.5 0 1 1 5.1 2.5z"
        />
      );
  }
}
